import React, { useEffect } from 'react';
import { Table, Input, Spinner, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import PropTypes from 'prop-types';
import { t } from '../common/Translate';
import { DefaultAlertModal } from '../common/Modal/DefaultAlertModal';
import { useOffersTable } from '../../hooks/usePricing/useOffersTable';
import { currencySign } from '../../Utils/currencySign';
import counterOfferDisplay from '../../Utils/counterOfferDisplay';

const OffersTable = (props) => {
  const {
    data,
    showPartner,
    dateFormat,
    saleStatus,
    saleId,
    supOfferId,
    recordId,
    partnerName,
    purchaseOrder,
    offers,
    isOfferLoading,
  } = props;
  const {
    sortFunction,
    isFinished,
    sortTypes,
    currentSortCreatedAt,
    currentSortAmount,
    validateBtn,
    cancelBtn,
    body,
    bodyCounterOffer,
    setBody,
    setBodyCounterOffer,
    changeCounterOfferAmount,
    handleSendCounterOffer,
    handlePutWinner,
    onSortChange,
    onChangeCounterOfferDetails,
    onChangeWinner,
    handleCancelCounterOffer,
    handleCancel,
    toggle,
    toggleCounterOffer,
    merchantName,
    isOpen,
    isOpenCounterOffer,
    counterOfferStatus,
    counterOfferAmount,
    inferiorCounterOffer,
    offerAmount,
    winner,
    isOpenEncheres,
    toggleEncheres,
    bodyEncheres,
    setBodyEncheres,
    handlePutEncheres,
    onChangeEncheres,
    handlePurchaseOffer,
    togglePurchaseOrder,
    isOpenPurchaseOrder,
    displayPurchaseOrder,
    purchaseOrderValue,
    bluring,
    enableAlcopaPickUpPlace,
    pickUpModal,
    setPickUpModal,
    isLoading,
    pickupSitesData,
    selectedWithdrawalSite,
    setSelectedWithdrawalSite,
    selectedBillingSite,
    setSelectedBillingSite,
    isSubmitting,
    handlePickupManagement,
    handlePickupData,
    errorMessage,
    postedPickupData,
    partnerOfferResponse,
    roleId,
  } = useOffersTable({
    recordId,
    saleId,
    saleStatus,
    offers,
    purchaseOrder,
  });

  const purchaseOrderData = purchaseOrderValue || purchaseOrder;

  useEffect(() => {
    if (isOpenCounterOffer) {
      setBodyCounterOffer(
        <>
          <div className="overflow-auto">
            <p className="font-weight-bold text-center">{t('textCounterOfferPopup')}</p>
            <span>
              <p className="font-weight-bold d-inline">{t('originalOffer')}</p>
              <p className="d-inline">{`   ${currencySign(offerAmount.toLocaleString())}`}</p>
            </span>
            <span>
              <br />
              <br />
            </span>
            <span className="d-block">
              <p className="font-weight-bold d-inline">{t('amountCounterOffer')}&nbsp;&nbsp;&nbsp;</p>
              <Input
                type="number"
                className="form-control rounded counter-offer-input"
                value={counterOfferAmount}
                onChange={(e) => changeCounterOfferAmount(e)}
              />
              <p className="font-weight-bold d-inline">&nbsp;&nbsp;{currencySign()}</p>
            </span>
            {inferiorCounterOffer && (
              <span className="d-block">
                <p>
                  <small className="font-weight-bold text-danger">{t('counterOfferSupOriginialOffer')}</small>
                </p>
              </span>
            )}
          </div>
        </>,
      );
    }
  }, [inferiorCounterOffer, isOpenCounterOffer, counterOfferAmount]);

  return (
    <>
      {isOpen &&
        !body &&
        merchantName &&
        setBody(
          <>
            <div className="overflow-auto">
              <p className="font-weight-bold">{(winner && t('confirmationAttribution1')) || t('deleteAttribution')}</p>
              <p className="font-weight-bold">{winner && t('confirmationAttribution2')}</p>
              <p>{(winner && t('confirmationAttribution3')) || t('confirmationAttribution2')}</p>
              <p>{!winner && t('deleteAttribution2')}</p>
            </div>
          </>,
        )}

      {isOpenEncheres &&
        !bodyEncheres &&
        setBodyEncheres(
          <>
            <div className="overflow-auto">
              {(() => {
                switch (partnerName) {
                  case 'vpauto':
                    return (
                      <>
                        <p className="font-weight-bold">{t('validationVpauto1')}</p>
                        <p>{t('validationVpauto2')}</p>
                      </>
                    );
                  case 'alcopa':
                    return (
                      <>
                        <p className="font-weight-bold">{t('validationAlcopa1')}</p>
                        <p>{t('validationAlcopa2')}</p>
                      </>
                    );
                  case 'mercier':
                    return (
                      <>
                        <p className="font-weight-bold">{t('validationMercier1')}</p>
                        <p>{t('validationMercier2')}</p>
                      </>
                    );
                  default:
                    return (
                      <>
                        <p className="font-weight-bold">{t('validationEncheresVo1')}</p>
                        <p>{t('validationEncheresVo2')}</p>
                      </>
                    );
                }
              })()}
            </div>
          </>,
        )}

      {/* {isOpenCounterOffer &&
        !bodyCounterOffer &&
        setBodyCounterOffer(
          <>
            <div className="overflow-auto">
              <p className="font-weight-bold text-center">{t('textCounterOfferPopup')}</p>
              <span>
                <p className="font-weight-bold d-inline">{t('originalOffer')}</p>
                <p className="d-inline">{`   ${offerAmount.toLocaleString()} €`}</p>
              </span>
              <span>
                <br />
                <br />
              </span>
              <span className="d-block">
                <p className="font-weight-bold d-inline">{t('amountCounterOffer')}&nbsp;&nbsp;&nbsp;</p>
                <Input
                  type="number"
                  className="form-control rounded counter-offer-input"
                  value={counterOfferAmount}
                  onChange={(e) => changeCounterOfferAmount(e)}
                />
                <p className="font-weight-bold d-inline">&nbsp;&nbsp;€</p>
              </span>
              {inferiorCounterOffer && <span className="d-block">
                <p>
                  <small className="font-weight-bold text-danger">{t('counterOfferSupOriginialOffer')}</small>
                </p>
              </span>}
            </div>
          </>,
        )} */}

      {data.length > 0 && (
        <Table bordered hover size="sm" responsive="sm" className="text-center subtitle offer-table">
          <thead className="offer-table-header">
            <tr>
              {!showPartner && <th>{t('merchantInfos')}</th>}
              {!showPartner && <th>{t('email')}</th>}
              {!showPartner && <th>{t('phoneNumber')}</th>}
              <th>
                {t('coverageCreationAt')}
                {!showPartner && (
                  <button className="icon-sortable" type="button" onClick={() => onSortChange('lastOfferCreatedAt')}>
                    <FontAwesomeIcon icon={sortTypes.lastOfferCreatedAt[currentSortCreatedAt].icon} />
                  </button>
                )}
              </th>
              <th>
                {t('coverageOffer')}
                {!showPartner && (
                  <button className="icon-sortable" type="button" onClick={() => onSortChange('amount')}>
                    <FontAwesomeIcon icon={sortTypes.amount[currentSortAmount].icon} />
                  </button>
                )}
              </th>
              {showPartner && partnerName === 'vpauto' && <th>{t('vpautoCommentOffer')}</th>}
              {showPartner && partnerName === 'encheresvo' && <th>{t('encheresvoCommentOffer')}</th>}
              {showPartner && partnerName === 'alcopa' && <th>{t('alcopaCommentOffer')}</th>}
              {showPartner && partnerName === 'mercier' && <th>{t('mercierCommentOffer')}</th>}
              {showPartner && <th>{t('commentOffer')}</th>}
              {partnerName === 'vpauto' && <th>{t('vpautocommentSupervisor')}</th>}
              {partnerName === 'encheresvo' && <th>{t('encheresvoCommentSupervisor')}</th>}
              {partnerName === 'alcopa' && <th>{t('alcopaCommentSupervisor')}</th>}
              {partnerName === 'mercier' && <th>{t('mercierCommentSupervisor')}</th>}
              {!showPartner && <th>{t('commentSupBuy')}</th>}
              {!showPartner && <th>{t('counterOffer')}</th>}
              {!showPartner && <th>{t('coverageAwarding')}</th>}
              {showPartner &&
                (partnerName === 'encheresvo' ||
                  partnerName === 'vpauto' ||
                  partnerName === 'alcopa' ||
                  partnerName === 'mercier') && <th>{t('acceptDeclineAuctioneer')}</th>}
              {showPartner &&
                partnerName === 'alcopa' &&
                offers.some((offer) => offer.partnerName === 'alcopa' && offer.partner_offer?.is_accepted) &&
                enableAlcopaPickUpPlace && <th>{t('pickUpPointSelection')}</th>}
              {!showPartner && winner && isFinished && displayPurchaseOrder && <th>{t('purchaseOrder')}</th>}
            </tr>
          </thead>
          <tbody className="offer-table-body">
            {[...data].sort(sortFunction).map((i) => (
              <tr key={i.id} className={isFinished && supOfferId === i.id ? 'row-offer-sup' : ''}>
                {!showPartner && <td className={bluring(purchaseOrderData, i) && 'blur'}>{t(i.partnerName)}</td>}
                {!showPartner && <td className={bluring(purchaseOrderData, i) && 'blur'}>{i.email && t(i.email)}</td>}
                {!showPartner && (
                  <td className={bluring(purchaseOrderData, i) && 'blur'}>{i.phoneNumber && t(i.phoneNumber)}</td>
                )}
                <td className={bluring(purchaseOrderData, i) && !showPartner && 'blur'}>
                  {(i.lastOfferCreatedAt && moment(i.lastOfferCreatedAt).format(dateFormat)) || null}
                </td>
                <td>
                  {i.value && i.value > 0 && currencySign(i.value)}{' '}
                  {isFinished && supOfferId === i.id && (
                    <svg
                      className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall column-offer-sup-star"
                      focusable="false"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      data-testid="true"
                      width="20"
                      height="20"
                    >
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" />
                    </svg>
                  )}
                </td>
                {showPartner && <td className="text-danger font-weight-bold large-comment">{i.offerComment}</td>}
                {showPartner && <td className="large-comment">{i.sale_comment}</td>}
                {showPartner && <td className="large-comment">{i.comment}</td>}
                {!showPartner && <td className="large-comment">{i.saleComment}</td>}
                {!showPartner && (
                  <td>{counterOfferDisplay(i, counterOfferStatus, saleStatus, winner, onChangeCounterOfferDetails)}</td>
                )}
                {(!showPartner ||
                  i.partnerName === 'encheresvo' ||
                  i.partnerName === 'partnerVpauto' ||
                  i.partnerName === 'alcopa' ||
                  i.partnerName === 'mercier') && (
                  <td className="align-middle">
                    {!(saleStatus === 'closed_no_purchase') && (
                      <div className="form-group">
                        {!showPartner ? (
                          <Input
                            checked={winner !== null && winner?.id === i?.id}
                            id={i.id}
                            type="checkbox"
                            disabled={
                              roleId === 1 ||
                              (isFinished ? (winner && !i.winner) || !(!isOfferLoading && saleId) : true)
                            }
                            className="checkbox-custom"
                            onChange={(e) => onChangeWinner(e, i)}
                          />
                        ) : (
                          <Input
                            checked={
                              partnerOfferResponse === 'boolean' || typeof i.partner_offer?.is_accepted === 'boolean'
                            }
                            id={i.id}
                            type="checkbox"
                            disabled={
                              roleId === 1 ||
                              !i.value ||
                              (i.partnerName === 'partnerVpauto' &&
                                typeof i.partner_offer?.is_accepted === 'boolean') ||
                              i.pickupConfirmed
                            }
                            className={
                              partnerOfferResponse === false || i.partner_offer?.is_accepted === false
                                ? `input-encheres`
                                : `checkbox-custom`
                            }
                            onChange={(e) => onChangeEncheres(e, i)}
                          />
                        )}
                        <label htmlFor={i.id}>&nbsp;</label>
                      </div>
                    )}
                  </td>
                )}
                {showPartner &&
                enableAlcopaPickUpPlace &&
                i.partnerName === 'alcopa' &&
                i.partner_offer?.is_accepted ? (
                  <td>
                    {i.pickupConfirmed || postedPickupData ? (
                      <div>
                        <small>
                          <p className="font-weight-bold">{t('pickUpManagementConfirmed')}:</p>
                        </small>
                        <small>
                          <p className="font-weight-bold">{i.pickupPlace}</p>
                        </small>
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-1 mr-2"
                        onClick={() => handlePickupManagement(i.partner_offer?.id)}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true" />
                            {t('loading')}...
                          </>
                        ) : (
                          t('pickupManagement')
                        )}
                      </button>
                    )}
                  </td>
                ) : (
                  <td />
                )}
                {!showPartner && winner && isFinished && displayPurchaseOrder && (
                  <td>
                    {(i.winner || i.counter_offer?.is_winner) && (
                      <>
                        {purchaseOrderData ? (
                          <>
                            <button
                              className="btn btn-3 btn-block px-1"
                              type="button"
                              onClick={() => togglePurchaseOrder()}
                              disabled={roleId === 1}
                            >
                              {t('sendAgainPurchaseOrder')}
                            </button>
                            <div className="purchase-bloc">
                              <small>
                                <p className="font-weight-bold">{purchaseOrderData && purchaseOrderData.name}</p>
                              </small>
                              <small>
                                <p className="font-weight-bold">
                                  {purchaseOrderData && moment(purchaseOrderData.created_at).format('YYYY/MM/DD HH:mm')}
                                </p>
                              </small>
                            </div>
                          </>
                        ) : (
                          <button
                            className="btn btn-1"
                            type="button"
                            onClick={() => togglePurchaseOrder()}
                            disabled={roleId === 1}
                          >
                            {t('sendPurchaseOrder')}
                          </button>
                        )}
                      </>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      <DefaultAlertModal
        isOpen={isOpen}
        toggle={toggle}
        withHeader={false}
        body={body}
        cancelBtn={cancelBtn}
        validateBtn={validateBtn}
        handleCancel={handleCancel}
        handleValidate={handlePutWinner}
        centered
        size="md"
      />
      <DefaultAlertModal
        isOpen={isOpenCounterOffer}
        toggle={toggleCounterOffer}
        withHeader={false}
        body={bodyCounterOffer}
        cancelBtn={cancelBtn}
        validateBtn={validateBtn}
        handleCancel={handleCancelCounterOffer}
        handleValidate={handleSendCounterOffer}
        centered
        size="md"
      />
      <DefaultAlertModal
        isOpen={isOpenEncheres}
        toggle={toggleEncheres}
        withHeader={false}
        body={bodyEncheres}
        cancelBtn={t('declinePrice')}
        validateBtn={t('acceptPrice')}
        handleCancel={() => handlePutEncheres(false)}
        handleValidate={() => handlePutEncheres(true)}
        centered
        size="md"
      />
      <DefaultAlertModal
        isOpen={isOpenPurchaseOrder}
        toggle={togglePurchaseOrder}
        withHeader={false}
        body={<p className="font-weight-bold text-center">{t('confirmationPurchaseOrder')}</p>}
        cancelBtn={cancelBtn}
        validateBtn={validateBtn}
        handleCancel={togglePurchaseOrder}
        handleValidate={handlePurchaseOffer}
        centered
        size="md"
      />

      <Modal isOpen={pickUpModal} toggle={() => setPickUpModal(!pickUpModal)} centered>
        <ModalHeader className="center-text font-weight-bold" toggle={() => setPickUpModal(!pickUpModal)}>
          {t('titlePickupManagement')}
        </ModalHeader>
        <ModalBody>
          <div className="mb-5">
            <p className="font-weight-normal mb-0">{t('alcopaPickUpPlace')}</p>
            <hr className="mt-0" />
            <div className="position-relative">
              <Input
                type="select"
                className="form-select border rounded px-3 py-1"
                style={{ boxShadow: 'none', appearance: 'none' }}
                value={selectedWithdrawalSite?.id || ''}
                onChange={(e) => {
                  const selected = pickupSitesData?.withdrawalSites.find((site) => site.id === e.target.value);
                  setSelectedWithdrawalSite(selected);
                }}
              >
                <option value="" aria-label="Select an option" disabled />
                {pickupSitesData?.withdrawalSites?.map((site) => (
                  <option key={site.id} value={site.id}>
                    {site.name}
                  </option>
                ))}
              </Input>
              <div className="custom-arrow">
                <div className="arrow-divider" />
                <span>
                  <FontAwesomeIcon icon={faCaretDown} />
                </span>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <p className="font-weight-normal mb-0">{t('alcopaBillingPlace')}</p>
            <hr className="mt-0" />
            <div className="position-relative">
              <Input
                type="select"
                className="form-select border rounded px-3 py-1"
                style={{ boxShadow: 'none', appearance: 'none' }}
                value={selectedBillingSite || ''}
                onChange={(e) => setSelectedBillingSite(e.target.value)}
              >
                <option value="" aria-label="Select an option" disabled />
                {pickupSitesData?.billingSites?.map((site) => (
                  <option key={site.id} value={site.id}>
                    {site.name}
                  </option>
                ))}
              </Input>
              <div className="custom-arrow">
                <div className="arrow-divider" />
                <span>
                  <FontAwesomeIcon icon={faCaretDown} />
                </span>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="p-4">
          <div className="model-footer d-flex flex-column w-100">
            <div className="d-flex">
              <button type="button" className="btn btn-3 mr-2" onClick={() => setPickUpModal(!pickUpModal)}>
                {t('canceledCta')}
              </button>
              <button type="button" className="btn btn-1" onClick={handlePickupData} disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true" />
                    {t('submitting')}...
                  </>
                ) : (
                  t('confirmationCta')
                )}
              </button>
            </div>
            {errorMessage && <p className="text-danger mt-2 mr-5 align-self-end">{t('missingRequiredFields')}</p>}
          </div>
        </ModalFooter>
      </Modal>

      {isOfferLoading && (
        <div className="loader-full-screen main">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default OffersTable;

OffersTable.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array]).isRequired,
  showPartner: PropTypes.bool.isRequired,
  saleStatus: PropTypes.string,
  dateFormat: PropTypes.string.isRequired,
  saleId: PropTypes.number.isRequired,
  recordId: PropTypes.string.isRequired,
  partnerName: PropTypes.string,
  supOfferId: PropTypes.number,
  purchaseOrder: {
    purchaseOrderNumber: PropTypes.string,
    purchaseOrderCreatedAt: PropTypes.string,
  },
  offers: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  isOfferLoading: PropTypes.bool.isRequired,
};

OffersTable.defaultProps = {
  saleStatus: null,
  partnerName: null,
  supOfferId: null,
  purchaseOrder: null,
};
